import { Severity, ShortfallOutcome } from './types'

export const DASHBOARD_API = '/api/internal/matching/dashboard'

export const REFRESH_STORAGE_KEY = 'matching-dashboard-refresh'
// Prefix of the stored mode of a KPI card that has modes; the metric key follows.
export const METRIC_MODE_STORAGE_PREFIX = 'matching-dashboard-mode-'
// Opens the "Все метрики" modal on load — makes the metrics view linkable
// without giving it a route of its own.
export const METRICS_QUERY_PARAM = 'metrics'
export { CURRENCY_STORAGE_KEY, DEFAULT_CURRENCY } from '../../../core/currency'
export const DEFAULT_REFRESH_MS = 20000

export const REFRESH_OPTIONS: Array<{ label: string; value: number }> = [
  { label: '5 сек', value: 5000 },
  { label: '10 сек', value: 10000 },
  { label: '20 сек', value: 20000 },
  { label: '40 сек', value: 40000 },
  { label: '60 сек', value: 60000 },
  { label: 'Пауза', value: 0 },
]

// Bootstrap contextual colors used for the health banner / badges.
export const SEVERITY_COLOR: Record<Severity, string> = {
  info: 'success',
  warning: 'warning',
  critical: 'danger',
}

export const SEVERITY_RANK: Record<Severity, number> = {
  info: 1,
  warning: 2,
  critical: 3,
}

export const OVERALL_TITLE: Record<Severity, string> = {
  info: 'Мэтчинг работает штатно',
  warning: 'Внимание',
  critical: 'Критично',
}

export const nf = new Intl.NumberFormat('ru-RU')

// Суммы в карточках KPI — в тысячах и миллионах, с двумя знаками: округление до
// десятых съедало разницу между соседними сутками, ради которой карточку и читают.
export const money = (v: number): string => {
  if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} млн ₽`
  if (Math.abs(v) >= 1_000) return `${(v / 1_000).toFixed(2)} тыс ₽`
  return `${v.toFixed(2)} ₽`
}

// Подписи режимов исхода выплат. Порядок — по глубине провала: не пустили на
// входе, взяли и никто не пришёл, пришли и ни разу не заплатили. «Все» — их
// сумма и значение по умолчанию.
export const SHORTFALL_OUTCOME_OPTIONS: Array<{ label: string; value: ShortfallOutcome }> = [
  { label: 'Все', value: 'all' },
  { label: 'Только не принятые', value: 'rejected' },
  { label: 'Принятые, но матчей не было', value: 'unmatched' },
  { label: 'Матчи были, но ни одной оплаты', value: 'matched_unpaid' },
]
